import { render, staticRenderFns } from "./OrderListCancelAll.vue?vue&type=template&id=200580ff&scoped=true"
import script from "./OrderListCancelAll.vue?vue&type=script&lang=js"
export * from "./OrderListCancelAll.vue?vue&type=script&lang=js"
import style0 from "./OrderListCancelAll.vue?vue&type=style&index=0&id=200580ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200580ff",
  null
  
)

export default component.exports